'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	return typeof Object.values === 'function' ? Object.values : implementation;
};



// WEBPACK FOOTER //
// ./node_modules/object.values/polyfill.js